<template>
  <h-s-table
    :headers="headers"
    :data="data"
    :header-key-mapping="headerKeyMapping"
    :row-clickable="rowClickable"
    @row-click="$emit('row-click', $event)"
  >
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}" />
    </template>
  </h-s-table>
</template>

<script>
import HSTable from "@/components/table/HSTable.vue";

export default {
  name: "HsDataTable",
  components: { HSTable },
  props: {
    headers: { type: Array, required: true },
    data: { type: Array, required: true },
    headerKeyMapping: { type: Object, required: true },
    rowClickable: { type: Boolean, default: false },
  },
  emits: ["row-click"],
};
</script>
